import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import {User} from '../model/Entities/User';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Customer} from '../model/Entities/Customer';

@Injectable()
export class CustomerService extends ApiService<Customer> {

    protected apiUrl = 'api/customers';  // URL to web api

    protected getObjectType(): any {
        return Customer;
    }
}



// WEBPACK FOOTER //
// /app/src/services/customer.service.ts